import { createEntityReducer } from 'ext/lib/collections';
import { TYPE } from './sdk-token-actions';

export default createEntityReducer(TYPE);

export const selectSDKToken = state => state[TYPE]?.jwt;
